'use client';

import { ReactNode, useContext, useEffect, useRef } from "react";
import './mobile-layout.scss';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { usePathname, useRouter } from "next/navigation";
import { RouterName } from "@/lib/enum/RouterEnum";
import { PAGE_MOBILE } from "@/lib/constants";
import { LetterScrambleSingleton } from "@/lib/utils/LetterScramble";
import ChangeAudioMute from "@/lib/utils/Audio";
import MobileShellContext from "@/components/Mobile/MobileShellContext";

const Mobile = ({ children }: { children: ReactNode }) => {
  const router = useRouter();
  const pathname = usePathname();
  const { currentSlide, openDirectory } = useContext(MobileShellContext);
  const isOnShowreel = pathname === '/' && currentSlide === PAGE_MOBILE.TITLE;

  useEffect(() => {
    const letterScrambler = LetterScrambleSingleton.getInstance();
    const timeoutId = setTimeout(() => {
      letterScrambler.startRandomOperations();
    }, 1000);

    return () => {
      letterScrambler.stopRandomOperations();
      clearTimeout(timeoutId);
    }
  }, []);

  useEffect(() => {
    const handleScroll = (e: Event) => {
      e.preventDefault();
    };

    document.body.style.overflow = 'hidden';
    window.addEventListener('scroll', handleScroll, { passive: false });

    return () => {
      document.body.style.overflow = 'auto';
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);


  const _goToDashboard = () => {
    router.push(RouterName.dashboard);
  };

  const audioRef = useRef<HTMLElement>(null);
  const _changeAudioMute = () => {
    ChangeAudioMute(audioRef, '.video-container video');
  }

  return (
    <>
      {/* Original GIF-based implementation. TODO: Remove this when video is confirmed to work well. */}
      {/* <div className="mobile-dirt-bg" /> */}
      <video
        className="mobile-dirt-bg-video"
        src="/assets/gif/DIRT.webm"
        autoPlay
        loop
        muted
        playsInline
      />
      <div className="mobile-container">
        <header className="header-mobile">
          <div className={'header-mobile-container'}>
            <div className='header-left-container'>
              <div className="logo-mobile-container" onClick={_goToDashboard}>
                <img
                  src="/assets/gif/BLOB.webp"
                  alt="Blob"
                  className="logo-mobile-image"
                  width={129}
                  height={120}
                  fetchPriority="high"
                />
              </div>
              <div className={'title-header letter-scrambler'}>THE OTHER LAB CO.</div>
            </div>
            <div className='header-right-container'>
              {isOnShowreel && (
                <div className='header-button' onClick={_changeAudioMute}>
                  <div className='audio-indicator-mobile' >
                    <div>SOUND</div>
                    <span ref={audioRef} className='audio-icon'>OFF</span>
                  </div>
                </div>
              )}
              <button
                type='button'
                className='hamburger-button'
                onClick={openDirectory}
                aria-label='Open directory menu'
              >
                <img
                  src='/assets/image/mobile/Hamburger.svg'
                  alt=''
                  aria-hidden='true'
                />
              </button>
            </div>
          </div>
          <div className="header-mobile-border"></div>
        </header>
        <main className="content-mobile">
          {children}
        </main>
      </div>
    </>
  )
};
export default Mobile;
